import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Store } from '../../types/vmdata'

const initialState: Store = {
  id: '',
  storeId: '',
  type: '',
  name: '',
  address: '',
  standAlone: true,
  logo: '',
  core: '',
  storeAvailableOnly: false,
  giftInShop: false,
  screensaverurl: '',
  enableTextToSpeech: false,
}

const store = createSlice({
  name: 'vm-bo/store',
  initialState,
  reducers: {
    setStoreData: (state, action: PayloadAction<Omit<Store, 'id'>>) => {
      return {
        ...state,
        ...action.payload,
        id: action.payload.storeId,
        standAlone: true,
      }
    },
    setStoreLogo: (state, action: PayloadAction<string>) => {
      return (state = { ...state, logo: action.payload })
    },
    setStoreCore: (state, action: PayloadAction<string>) => {
      return (state = { ...state, core: action.payload, storeId: '' })
    },
    setStoreAvailableOnly: (state, action: PayloadAction<boolean>) => {
      return (state = { ...state, storeAvailableOnly: action.payload })
    },
    setgiftInShop: (state, action: PayloadAction<boolean>) => {
      return (state = { ...state, giftInShop: action.payload })
    },
    setStoreID: (state, action: PayloadAction<string>) => {
      return (state = { ...state, storeId: action.payload })
    },
    setScreensaverURL: (state, action: PayloadAction<string>) => {
      return (state = { ...state, screensaverurl: action.payload })
    },
    setEnableTextToSpeech: (state, action: PayloadAction<boolean>) => {
      return (state = { ...state, enableTextToSpeech: action.payload })
    },
  },
})

export const {
  setStoreData,
  setStoreLogo,
  setStoreCore,
  setStoreAvailableOnly,
  setgiftInShop,
  setStoreID,
  setScreensaverURL,
  setEnableTextToSpeech,
} = store.actions
export default store.reducer
